import AnalyticsQueryString from '@component/common/src/util/AnalyticsQueryString';
import Cookie from '@component/common/src/util/Cookie';
import Logger from '@component/common/src/util/Logger';
import { getProperty } from './PropertyGetter';

const recipeSet = new Set();

const getRecipeSet = () => recipeSet;

function setRecipeSet(recipes) {
  if (!Array.isArray(recipes)) {
    return;
  }

  recipeSet.clear();
  Logger.log('Recipes from @componenent/experiment received = ', recipes);
  recipes.forEach(recipe => recipeSet.add(recipe));
}

const isRecipeSelected = (recipe) => {
  const EXPERIMENT_RECIPE_PARAMETER = 'pdp_exp';
  const PARAMS = AnalyticsQueryString.buildQueryMap(window.location.href.toLowerCase());

  if (PARAMS[EXPERIMENT_RECIPE_PARAMETER]) {
    return PARAMS[EXPERIMENT_RECIPE_PARAMETER].toLowerCase().split(',').includes(recipe);
  } else if (Cookie.get('pdp_exp')) {
    return Cookie.get('pdp_exp').toLowerCase().split(',').includes(recipe);
  }

  return recipeSet.has(recipe);
};

function styliticsWidgetA(productModel) {
  const forcedTest = 'styliticsa';
  const EXPERIMENT_RECIPE = '636-21';

  return (
    !getProperty(productModel.get('product'), 'detail.flags.masterProduct') &&
    isRecipeSelected(EXPERIMENT_RECIPE) &&
    productModel.get('uiKillSwitches').pdpStyliticsOutFittingWidgetEnabled
  ) || isRecipeSelected(forcedTest);
}

function styliticsWidgetB(productModel) {
  const forcedTest = 'styliticsb';
  const EXPERIMENT_RECIPE = '636-22';

  return (
    !getProperty(productModel.get('product'), 'detail.flags.masterProduct') &&
    !styliticsWidgetA(productModel) &&
    isRecipeSelected(EXPERIMENT_RECIPE) &&
    productModel.get('uiKillSwitches').pdpStyliticsOutFittingWidgetEnabled
  ) || isRecipeSelected(forcedTest);
}

function hexa(productModel) {
  const forcedTest = 'hexa';
  const EXPERIMENT_RECIPE = '676-21';

  return (
    getProperty(productModel.get('product'), 'availability.available') &&
    isRecipeSelected(EXPERIMENT_RECIPE) &&
    productModel.get('uiKillSwitches').hexaEnabled
  ) || isRecipeSelected(forcedTest);
}

const clientSideExperimentationFlags = (productModel) => {
  if (productModel.get('productNotFoundError')) {
    return {};
  }

  return {
    hexa: hexa(productModel),
    styliticsWidgetA: styliticsWidgetA(productModel),
    styliticsWidgetB: styliticsWidgetB(productModel),
  };
};

export {
  getRecipeSet,
  setRecipeSet,
  isRecipeSelected,
  clientSideExperimentationFlags,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/ExperimentationUtil.js